import { render, staticRenderFns } from "./VendorTile.vue?vue&type=template&id=fd7cb3c8&scoped=true&"
import script from "./VendorTile.vue?vue&type=script&lang=js&"
export * from "./VendorTile.vue?vue&type=script&lang=js&"
import style0 from "./VendorTile.vue?vue&type=style&index=0&id=fd7cb3c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd7cb3c8",
  null
  
)

export default component.exports